{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "すべてのオプションを見る",
  "Spoiler_Reveal_Tooltip": "クリックして表示",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "ツイートする",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "アイテムが折りたたまれました",
  "Spoiler_Reveal_Video_CTA": "ぼかしを外す",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "画像を拡大",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "すべての結果を表示",
  "Spoiler_Reveal_Image_Placeholder": "この画像にはぼかしが入っています",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "シークバー",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "複数の回答に投票することができます。",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "その他のオーディオコントロールを表示",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "閉じる",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "読み込み中：{{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "ユーザーアバター",
  "Preview_ReadMore_Label": "続きを読む",
  "Spoiler_Insert_Tooltip": "ぼかし",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "検索数",
  "Spoiler_Reveal_Gallery_Placeholder": "このギャラリーにはぼかしが入っています",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "今すぐ予約",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "ミュートを解除",
  "Spoiler_Reveal_Gallery_CTA": "ぼかしを外す",
  "Poll_Viewer_ShowLess_CTA": "折りたたむ",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "ミュート",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}}名 匿名ゲスト",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "フォロー",
  "VerticalEmbed_Products_Button": "購入する",
  "Poll_Viewer_Toast_Error_ServerDown": "サーバーに接続できませんでした。後ほどお試しください。",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}}人がこの回答に投票しました",
  "Poll_Viewer_VoteCount": "{{number}}件の投票",
  "VerticalEmbed_Events_Button": "今すぐ登録",
  "Spoiler_Reveal_Image_CTA": "ぼかしを外す",
  "Poll_Viewer_Toast_Error_Connection": "問題が発生しました。接続状況をご確認ください",
  "Poll_Viewer_Visibility_Owner_Footer": "自分だけが結果を見ることができます。",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}}人がこの回答に投票しました",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "アイテムが展開されました",
  "Audio_Plugin_Cover_Alt": "音声カバー",
  "Spoiler_Reveal_Video_Placeholder": "この動画にはぼかしが入っています",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "記事全文を表示",
  "UploadFile_Viewer_Download": "ダウンロード：{{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}時間",
  "VerticalEmbed_Units_Minute": "{{minutes}}分",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
